import Castilo1 from '../Castilo/Castilo (1).webp'
import Castilo2 from '../Castilo/Castilo (2).webp'





const Castiloimages =[
Castilo1,Castilo2
]

export default Castiloimages;